import axios from 'axios'

import { authenticatedErrorResponseInterceptor } from '../../../interceptors/http-interceptor/errorAuthenticated'
import { errorRequestInterceptor } from '../../../interceptors/http-interceptor/errorRequest'
import { responseInterceptor } from '../../../interceptors/http-interceptor/response'
import { authenticatedRequestInterceptorBO } from '../../../interceptors/http-interceptor/authenticatedBO'

export const configureAuthenticatedAPIBO = (
  url: string,
  apiKey?: string,
  useInterceptors?: boolean
) => {
  const instance = axios.create({
    headers: { Authorization: apiKey ? `${apiKey}` : undefined },
    baseURL: url
  })

  if (useInterceptors) {
    instance.interceptors.request.use(
      authenticatedRequestInterceptorBO,
      errorRequestInterceptor
    )
    instance.interceptors.response.use(
      responseInterceptor,
      authenticatedErrorResponseInterceptor
    )
  }

  return instance
}
